import { FaStar } from 'react-icons/fa'
import { DateTime } from 'luxon'

import {
  Container,
  RatingContainer,
  Info,
  Row,
  Image,
  SubTitle,
  InfoText
} from './styles'

export default function Rating ({ data: rating }) {
  return (
    <Container>
      <Row>
        <Image src={rating.member.profile_picture}/>
        <Info>
          <Row>
            <RatingContainer>
              <FaStar size={16} color='#FFC100'/>
              <SubTitle>
                {rating.value}
              </SubTitle>
            </RatingContainer>
            <InfoText>
              <SubTitle>
                {rating.member.name}
              </SubTitle>
              ({DateTime.fromISO (rating.created_at).toFormat ('dd/MM/yyyy')})
            </InfoText>
          </Row>
          <InfoText>
            {rating.comment}
          </InfoText>
        </Info>
      </Row>
    </Container>
  )
}
